module.exports = __webpack_public_path__ + "static/media/eye.5b8e7dfc.svg";